import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@chakra-ui/react'
import HTMLWrapper from 'lib/html-wrapper'

const CarouselDescription = ({ data, theme, dataTestId }) => {
  return (
    <Text
      color={theme.textColor}
      fontFamily='body'
      fontSize={`${theme.descriptionFontSize}em` || 'body'}
      fontWeight={theme.descriptionFontWeight || 'body'}
      lineHeight='tall'
      wordBreak='break-word'
      data-testid={dataTestId}
    >
      <HTMLWrapper html={data.description} allowTags={['br', '&', 'p']} truncateLength={theme.descriptionLength || 90} />
    </Text>
  )
}

CarouselDescription.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default CarouselDescription
